/// <reference types="telegram-web-app" />

export interface Well {
  id: string;
  api: string;
  wellName: string;
  operator: string;
  latitude: number;
  longitude: number;
  status: string;
  basin: string;
  county: string;
  state?: string;
  type?: string;
  facilityType?: string; // e.g., "Tank Battery - (TB)", "Compressor Station - (CS)"
  spudDate?: string;
  completionDate?: string;
  totalDepth?: number;
  wellType?: string;
  distance?: number;
}

export interface UserSubscription {
  userId: string;
  tier: 'free' | 'basic' | 'premium';
  expiresAt?: Date;
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
}

export interface UserFavorite {
  id: number;
  userId: string;
  wellId: number;
  createdAt: Date;
}

export interface BasinInfo {
  id: string;
  name: string;
  description: string;
  region: string;
  bounds: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
  center: {
    lat: number;
    lng: number;
  };
}

// County-based filtering for well searches
export interface CountyInfo {
  name: string;
  wells: number;
  basin: string;
}

export const NEW_MEXICO_COUNTIES: CountyInfo[] = [
  { name: 'Bernalillo', wells: 0, basin: 'Central' },
  { name: 'Catron', wells: 0, basin: 'Southwest' },
  { name: 'Chaves', wells: 0, basin: 'Southeast' },
  { name: 'Cibola', wells: 0, basin: 'Northwest' },
  { name: 'Colfax', wells: 0, basin: 'Northeast' },
  { name: 'Curry', wells: 0, basin: 'East' },
  { name: 'De Baca', wells: 0, basin: 'East' },
  { name: 'Dona Ana', wells: 0, basin: 'South' },
  { name: 'Eddy', wells: 0, basin: 'Delaware' },
  { name: 'Grant', wells: 0, basin: 'Southwest' },
  { name: 'Guadalupe', wells: 0, basin: 'East' },
  { name: 'Harding', wells: 0, basin: 'Northeast' },
  { name: 'Hidalgo', wells: 0, basin: 'Southwest' },
  { name: 'Lea', wells: 0, basin: 'Delaware' },
  { name: 'Lincoln', wells: 0, basin: 'Southeast' },
  { name: 'Los Alamos', wells: 0, basin: 'Northwest' },
  { name: 'Luna', wells: 0, basin: 'Southwest' },
  { name: 'McKinley', wells: 0, basin: 'Northwest' },
  { name: 'Mora', wells: 0, basin: 'Northeast' },
  { name: 'Otero', wells: 0, basin: 'South' },
  { name: 'Quay', wells: 0, basin: 'East' },
  { name: 'Rio Arriba', wells: 0, basin: 'Northwest' },
  { name: 'Roosevelt', wells: 0, basin: 'Southeast' },
  { name: 'Sandoval', wells: 0, basin: 'Northwest' },
  { name: 'San Juan', wells: 0, basin: 'San Juan' },
  { name: 'San Miguel', wells: 0, basin: 'Northeast' },
  { name: 'Santa Fe', wells: 0, basin: 'North Central' },
  { name: 'Sierra', wells: 0, basin: 'Southwest' },
  { name: 'Socorro', wells: 0, basin: 'Southwest' },
  { name: 'Taos', wells: 0, basin: 'North' },
  { name: 'Torrance', wells: 0, basin: 'Central' },
  { name: 'Union', wells: 0, basin: 'Northeast' },
  { name: 'Valencia', wells: 0, basin: 'Central' }
];

// Basins kept for offline map downloads only
export type Basin = 'permian' | 'delaware' | 'san-juan' | 'raton';

export const BASINS: Record<Basin, BasinInfo> = {
  'permian': {
    id: 'permian',
    name: 'Permian Basin',
    description: 'Southeast New Mexico',
    region: 'Southeast',
    bounds: { north: 33.5, south: 31.5, east: -103.0, west: -104.5 },
    center: { lat: 32.5, lng: -103.75 }
  },
  'delaware': {
    id: 'delaware',
    name: 'Delaware Basin',
    description: 'Eddy & Lea Counties',
    region: 'Southeast',
    bounds: { north: 33.0, south: 32.0, east: -103.5, west: -104.5 },
    center: { lat: 32.5, lng: -104.0 }
  },
  'san-juan': {
    id: 'san-juan',
    name: 'San Juan Basin',
    description: 'Northwest New Mexico',
    region: 'Northwest',
    bounds: { north: 37.0, south: 35.5, east: -107.0, west: -109.0 },
    center: { lat: 36.25, lng: -108.0 }
  },
  'raton': {
    id: 'raton',
    name: 'Raton Basin',
    description: 'Northeast New Mexico',
    region: 'Northeast',
    bounds: { north: 37.0, south: 36.0, east: -104.0, west: -105.0 },
    center: { lat: 36.5, lng: -104.5 }
  }
};
